var _desc, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "H\xECnh \u1EA3nh s\u1EA3n ph\u1EA9m m\u1EB7c \u0111\u1ECBnh") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Bi\u1EC3u t\u01B0\u1EE3ng s\u1EA3n ph\u1EA9m ch\u01B0a c\xF3 h\xECnh \u1EA3nh")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 8,
    fill: "#e8eef8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 29 40 20l18 9v22L40 60l-18-9V29Z",
    fill: "#fff",
    stroke: "#1b5fc6",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22 29 18 10 18-10M40 39v21",
    fill: "none",
    stroke: "#1b5fc6",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25.5 49 35",
    fill: "none",
    stroke: "#8da9d8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProduct);
export default __webpack_public_path__ + "static/media/default-product.3377a8ec84256f8ea3ac6c25d7733387.svg";
export { ForwardRef as ReactComponent };